var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{staticClass:"table"},[_c('tr',[_c('th',{staticClass:"text-align-center td-wrap"},[_c('img',{staticClass:"mb-2",attrs:{"src":_vm.imgSrc,"width":"24","height":"24"}}),_c('h4',[_c('a',{attrs:{"href":_vm.href}},[_vm._v(_vm._s(_vm.text))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }